// HOC the set the theme
import withTheme from '@automotivetech/withtheme/dist';

// ICONS
import ICONS from '@automotivetech/icons/dist/static/media/icons.svg';

// WhatCar? Logo
import whatcarLogo from '@automotivetech/icons/dist/static/media/whatcar_logo.svg';

// Icon
import iconStyle from '@automotivetech/icon/dist/static/media/index.css';
import Icon from '@automotivetech/icon/dist/';

// Header
import HeaderWc from '@automotivetech/headerwc/dist/';
import headerWcStyle from '@automotivetech/headerwc/dist/static/media/index.css';

// Footer
import FooterWc from '@automotivetech/footerwc/dist/';
import footerWcStyle from '@automotivetech/footerwc/dist/static/media/index.css';

// Button Switch
import ButtonSwitch from '@automotivetech/buttonswitch/dist';
import buttonSwitchStyle from '@automotivetech/buttonswitch/dist/static/media/index.css';

// WithViewport
import WithViewport from '@automotivetech/withviewport/dist/';

// hayPropTypes
import hayPropTypes from '@automotivetech/hayproptypes/dist/';

headerWcStyle.iconSearch = `${ICONS}#wci-search`;
headerWcStyle.iconArrowDown = `${ICONS}#wci-arrow-down`;
headerWcStyle.iconArrowUp = `${ICONS}#wci-arrow-up`;
headerWcStyle.iconMobileMenu = `${ICONS}#wci-burger`;
headerWcStyle.iconMyDeals = `${ICONS}#wci-car`;
headerWcStyle.iconMobileMenuClose = `${ICONS}#wci-cross`;
headerWcStyle.iconAvatar = `${ICONS}#wci-avatar`;
headerWcStyle.iconHeartFilled = `${ICONS}#wci-heart-filled`;
headerWcStyle.iconHeartEmpty = `${ICONS}#wci-heart`;
headerWcStyle.iconCompare = `${ICONS}#wci-compare-icon`;
headerWcStyle.logoSVG = whatcarLogo;
headerWcStyle.style = headerWcStyle;
const HeaderWcWC = withTheme(HeaderWc, headerWcStyle);

footerWcStyle.accordionIcon = {
  iconOpen: `${ICONS}#wci-arrow-up`,
  iconClosed: `${ICONS}#wci-arrow-down`
};
footerWcStyle.iconSvg = ICONS;
footerWcStyle.style = footerWcStyle;
const FooterWcWC = withTheme(FooterWc, footerWcStyle);

const IconWC = withTheme(Icon, iconStyle);
const ButtonSwitchWC = withTheme(ButtonSwitch, buttonSwitchStyle);

export {
  ICONS,
  hayPropTypes,
  IconWC as Icon,
  WithViewport,
  HeaderWcWC as Header,
  FooterWcWC as Footer,
  ButtonSwitchWC as ButtonSwitch
};



// WEBPACK FOOTER //
// ./src/Olympus/index.js